import { render, staticRenderFns } from "./card-dictionary.vue?vue&type=template&id=59b26e10&scoped=true"
import script from "./card-dictionary.vue?vue&type=script&lang=js"
export * from "./card-dictionary.vue?vue&type=script&lang=js"
import style0 from "./card-dictionary.vue?vue&type=style&index=0&id=59b26e10&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59b26e10",
  null
  
)

export default component.exports